import React from "react";
import { useRouteMatch } from "react-router";
import { Link } from "react-router-dom";
import { List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { ExitToApp, LibraryMusic, Money } from "@material-ui/icons";
import { paths } from "frontend/src/pages/paths/index";
import { logout } from "frontend/src/features/session";
import { useTranslation } from "react-i18next";
import { locales } from "../../../domain/localization/i18n";
var Item = function (_a) {
    var url = _a.url, name = _a.name, icon = _a.icon;
    var match = useRouteMatch(url);
    return (React.createElement(ListItem, { button: true, selected: Boolean(match), component: Link, to: url },
        React.createElement(ListItemIcon, null, icon),
        React.createElement(ListItemText, { primary: name })));
};
var path = paths.rightholder;
export var Navigation = function () {
    var t = useTranslation(locales.namespaces.rightholder).t;
    var onExit = function () { return logout(); };
    return (React.createElement(List, null,
        React.createElement(Item, { name: t("layout.tracks"), url: path.tracks.index(), icon: React.createElement(LibraryMusic, null) }),
        React.createElement(Item, { name: t("layout.payments"), url: path.earnings.index(), icon: React.createElement(Money, null) }),
        React.createElement(ListItem, { button: true, onClick: onExit },
            React.createElement(ListItemIcon, null,
                React.createElement(ExitToApp, null)),
            React.createElement(ListItemText, { primary: t("layout.exit") }))));
};
